<template>
  <div id="mainContainer">
       <router-view></router-view>
      <!--<v-home></v-home>-->
  </div>
</template>

<script>
import Home from './component/Home.vue'


  export default {
      data () {
        return {
          msg:""
        }
      },
      components:{
        "v-home":Home
      }
  }
</script>

<style>
body {
  font-family: Helvetica, sans-serif;
}
#mainContainer{
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}


</style>



// WEBPACK FOOTER //
// App.vue?1d17e55e